import React, { useState } from "react";
import { X } from "lucide-react";
import { siteConfig } from "../siteConfig";
import Reveal from "../components/Reveal";

const GalleryPage = () => {
  const [lightbox, setLightbox] = useState(null);

  return (
    <>
      <section
        className="relative flex items-end"
        style={{
          minHeight: "38vh",
          backgroundImage: `url(${siteConfig.hero.image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.45) 100%)" }} />
        <div className="relative z-10 w-full max-w-7xl mx-auto px-5 md:px-8 pb-12 pt-32">
          <p className="text-xs font-black uppercase tracking-widest mb-3" style={{ color: siteConfig.colors.primary }}>
            Our Work
          </p>
          <h1 className="font-display font-black text-white leading-tight mb-3" style={{ fontSize: "clamp(2.2rem,5vw,3.75rem)" }}>
            Project Gallery
          </h1>
          <p className="text-white/70 text-lg max-w-2xl">
            Browse our recent projects and see the craftsmanship we bring to every outdoor space.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
            {siteConfig.gallery.map((img, i) => (
              <Reveal
                as="button"
                key={i}
                delay={(i % 4) * 80}
                className="group rounded-xl overflow-hidden aspect-square block cursor-zoom-in"
                onClick={() => setLightbox(i)}
              >
                <img
                  src={img}
                  alt={`Project ${i + 1}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-5 right-5 text-white/70 hover:text-white"
            onClick={() => setLightbox(null)}
          >
            <X className="w-8 h-8" />
          </button>
          <img
            src={siteConfig.gallery[lightbox]}
            alt={`Project ${lightbox + 1}`}
            className="max-w-[90vw] max-h-[85vh] object-contain rounded-xl"
            onClick={(e) => e.stopPropagation()}
          />
          <div className="absolute bottom-5 text-white/50 text-sm">
            {lightbox + 1} / {siteConfig.gallery.length}
          </div>
        </div>
      )}

    </>
  );
};

export default GalleryPage;
